import { createStyles, Theme } from '@material-ui/core/styles';

const styles = ({ spacing, colors }: Theme) => createStyles({
  root: {
    overflow: 'hidden',
    paddingTop: spacing(3),
    paddingBottom: spacing(3),
  },
  name: {
    display: 'inline',
    cursor: 'pointer',
    color: colors.navigation.topBar.title,
  },
});

export default styles;
